import { useSelector, useDispatch } from "react-redux";
import { addItem, clearCart } from "../utils/cartSlice";
import RestroItems from "./Items";
const Cart = () => {
    const dispatch = useDispatch();
    const cartItems = useSelector((store) => store.cart.items);
    const handleDispatch = () => {
        dispatch(clearCart());
    };
    const handleAddToCart = (item) => {
        dispatch(addItem(item));
    };
    return (
        <div className="w-6/12 mx-auto">
            {cartItems.length === 0 && <h1>Cart is empty</h1>}
            <RestroItems menuInfo={cartItems} handleAddToCart={handleAddToCart} />
            <button className="bg-black text-white p-2 hover:cursor-pointer rounded-lg" onClick={handleDispatch}>
                Clear Cart
            </button>
        </div>
    );
};
export default Cart;
